module.exports = __webpack_public_path__ + "static/video-play-button-6fab7f2870502edd4e476d9be24dbb9c.png";